import StandardCalendar from './standard'
import DaysAndCalendar from './daysand'
import StrictCalendar from './strict'
export * from './utility'

/**
 * Calendar オブジェクトを作成する
 *
 * @param {{period: Object, dates: Object[]}} cal カレンダー情報
 * @param {String} type カレンダータイプ
 * @param {String} by カレンダーの用途
 * @return {Calendar} Calendar オブジェクトを返す
 */
export function create (cal, type = 'standard', by = 'allows') {
  if (type === 'daysand') {
    return new DaysAndCalendar(cal, by)
  } else if (type === 'strict') {
    return new StrictCalendar(cal, by)
  }
  return new StandardCalendar(cal, by)
}
